<template>
  <div>
    <el-drawer
      :visible.sync="drawer"
      title="消息通知"
      size="50%"
      @close="closeDrawer"
    >
      <div class="news-container" v-loading="loading">
        <el-timeline>
          <el-timeline-item
            placement="top"
            v-for="(activity, index) in data"
            :key="index"
            :timestamp="moment(activity.CreateTime).format('YYYY-MM-DD HH:mm')"
          >
            <el-badge
              is-dot
              class="item-badge"
              style="width: 100%"
              :hidden="activity.Status != 0"
            >
              <el-card
                class="message-card"
                @click.native="markAsRead(activity)"
              >
                <div class="message-header">
                  <h4>
                    <span style="font-size: 14px">项目名称：</span
                    >{{ activity.ProjectName }}
                  </h4>
                  <el-tag
                    :type="activity.Status == 0 ? 'danger' : 'info'"
                    size="mini"
                  >
                    {{ activity.Status == 0 ? '未读' : '已读' }}
                  </el-tag>
                </div>
                <p>{{ activity.Content }}</p>
              </el-card>
            </el-badge>
          </el-timeline-item>
        </el-timeline>
        <el-empty description="暂无数据" v-if="data.length == 0"></el-empty>
      </div>

      <el-pagination
        class="pagination-container"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="pagination.pageSizes"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      >
      </el-pagination>
    </el-drawer>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data() {
    return {
      moment,
      drawer: false,
      loading: false,
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
        pageSizes: [20, 40, 80, 100],
      },
      data: [],
      userId: '',
    }
  },
  computed: {},
  methods: {
    handleSizeChange(size) {
      this.pagination.currentPage = 1
      this.pagination.pageSize = size
      this.getDataList()
    },
    handleCurrentChange(page) {
      this.pagination.currentPage = page
      this.getDataList()
    },
    openDrawer(userId) {
      this.drawer = true
      this.userId = userId
      this.data = []
      this.pagination.currentPage = 1
      this.getDataList()
    },
    closeDrawer() {
      this.drawer = false
    },
    getDataList() {
      this.loading = true
      this.$http
        .post(
          '/Operation_Manage/Operation_Notify/GetAdminSideOperationNotifyList',

          {
            PageIndex: this.pagination.currentPage,
            PageRows: this.pagination.pageSize,
            SortField: 'CreateTime',
            SortType: 'desc',
            Search: [
              {
                Condition: 'ProjectManagerId',
                Keyword: this.userId,
              },
              {
                Condition: 'Type',
                Keyword: 0,
              },
            ],
          }
        )
        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.data = res.Data
            this.pagination.total = res.Total
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    markAsRead(activity) {
      if (activity.Status !== 0) {
        console.log('该消息已读')
        return
      }

      this.loading = true
      this.$http
        .post(
          '/Operation_Manage/Operation_Notify/SaveAdminSideOperationNotify',
          {
            id: activity.Id,
          }
        )
        .then((res) => {
          this.loading = false
          if (res.Success) {
            activity.Status = 1 // 更新本地状态
            this.$notify.success('标记已读')
            this.getDataList() // 刷新列表
          } else {
            this.$notify.error(res.Msg || '操作失败')
          }
        })
        .catch((err) => {
          console.error('请求错误:', err)
          this.loading = false
          this.$notify.error('操作失败')
        })
    },
  },
  watch: {
    drawer(newVal) {
      if (!newVal) {
        this.$emit('close')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.news-container {
  padding: 20px;
  height: calc(100vh - 140px);
  box-sizing: border-box;
  overflow-y: auto;
  .el-timeline-item {
    .message-card {
      .message-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;

        h4 {
          margin: 0;
          font-size: 16px;
          font-weight: 600;
          color: #303133;
        }
      }

      p {
        margin: 0;
        color: #666;
        font-size: 14px;
        line-height: 1.6;
      }
    }
  }
}
.pagination-container {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: right;
  margin-top: 10px;
  padding-right: 20px;
}
::v-deep .item-badge .el-badge__content {
  right: 10px !important;
  top: -1px !important;
  width: 10px !important;
  height: 10px !important;
}
</style>
